// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/demand_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { WorkflowCaseStatus } from "./workflow_case_model_pb";
import { file_bffuser_v1_workflow_case_model } from "./workflow_case_model_pb";
import type { WorkflowSection } from "./workflow_template_model_pb";
import { file_bffuser_v1_workflow_template_model } from "./workflow_template_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/demand_service.proto.
 */
export const file_bffuser_v1_demand_service: GenFile = /*@__PURE__*/
  fileDesc("Ch9iZmZ1c2VyL3YxL2RlbWFuZF9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIo8DChpMaXN0RGVtYW5kRm9yZWNhc3RzUmVxdWVzdBI8CghzZWN0aW9ucxgBIAMoDjIbLmJmZnVzZXIudjEuV29ya2Zsb3dTZWN0aW9uQg26SAqSAQciBYIBAhABEjAKEHRhcmdldF9kYXRlX2Zyb20YAiABKAsyES5nb29nbGUudHlwZS5EYXRlSACIAQESLgoOdGFyZ2V0X2RhdGVfdG8YAyABKAsyES5nb29nbGUudHlwZS5EYXRlSAGIAQESKQoKYXJlYV9jb2RlcxgEIAMoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlEj0KBnN0YXR1cxgFIAEoDjIeLmJmZnVzZXIudjEuV29ya2Zsb3dDYXNlU3RhdHVzQgi6SAWCAQIQAUgCiAEBEh4KEWhhc19hY3R1YWxfZmlsdGVyGAYgASgISAOIAQFCEwoRX3RhcmdldF9kYXRlX2Zyb21CEQoPX3RhcmdldF9kYXRlX3RvQgkKB19zdGF0dXNCFAoSX2hhc19hY3R1YWxfZmlsdGVyIkoKG0xpc3REZW1hbmRGb3JlY2FzdHNSZXNwb25zZRIrCgRyb3dzGAEgAygLMh0uYmZmdXNlci52MS5EZW1hbmRGb3JlY2FzdFJvdyKgBQoRRGVtYW5kRm9yZWNhc3RSb3cSDwoHY2FzZV9pZBgBIAEoCRImCgt0YXJnZXRfZGF0ZRgDIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSLAoHc2VjdGlvbhgEIAEoDjIbLmJmZnVzZXIudjEuV29ya2Zsb3dTZWN0aW9uEigKCWFyZWFfY29kZRgFIAEoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlEhQKB2JnX2NvZGUYBiABKAlIAIgBARIuCgZzdGF0dXMYByABKA4yHi5iZmZ1c2VyLnYxLldvcmtmbG93Q2FzZVN0YXR1cxI1Cgxjb21wbGV0ZWRfYXQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAGIAQESGQoMY29tcGxldGVkX2J5GAkgASgJSAKIAQESMQoOcGVha19kZW1hbmRfbXcYCiABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsSAOIAQESLQoKZW5lcmd5X213aBgLIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWxIBIgBARIuCgpjcmVhdGVkX2F0GAwgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBITCgt3b3JrZmxvd19pZBgNIAEoCRIWCglyZWNvcmRfaWQYDiABKAlIBYgBARISCgpoYXNfYWN0dWFsGA8gASgIEhQKB2JnX25hbWUYECABKAlIBogBAUIKCghfYmdfY29kZUIPCg1fY29tcGxldGVkX2F0Qg8KDV9jb21wbGV0ZWRfYnlCEQoPX3BlYWtfZGVtYW5kX213Qg0KC19lbmVyZ3lfbXdoQgwKCl9yZWNvcmRfaWRCCgoIX2JnX25hbWVKBAgCEANSCWNhc2VfbmFtZTJ5Cg1EZW1hbmRTZXJ2aWNlEmgKE0xpc3REZW1hbmRGb3JlY2FzdHMSJi5iZmZ1c2VyLnYxLkxpc3REZW1hbmRGb3JlY2FzdHNSZXF1ZXN0GicuYmZmdXNlci52MS5MaXN0RGVtYW5kRm9yZWNhc3RzUmVzcG9uc2UiAEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_bffuser_v1_workflow_case_model, file_bffuser_v1_workflow_template_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * ListDemandForecastsRequest carries filter parameters for the demand forecast
 * list. All filters are optional; unset means no filtering on that dimension.
 *
 * @generated from message bffuser.v1.ListDemandForecastsRequest
 */
export type ListDemandForecastsRequest = Message<"bffuser.v1.ListDemandForecastsRequest"> & {
  /**
   * sections filters by the operational period. empty = no filtering.
   * Multiple values (= 単日タブ) merge those sections' rows server-side; the
   * frontend distinguishes them per-row via DemandForecastRow.section.
   *
   * @generated from field: repeated bffuser.v1.WorkflowSection sections = 1;
   */
  sections: WorkflowSection[];

  /**
   * target_date_from / target_date_to form an inclusive date range filter.
   * Daily 3-tab screen passes from = to = selected date.
   *
   * @generated from field: optional google.type.Date target_date_from = 2;
   */
  targetDateFrom?: Date;

  /**
   * @generated from field: optional google.type.Date target_date_to = 3;
   */
  targetDateTo?: Date;

  /**
   * area_codes filters by area. empty = no filtering.
   *
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 4;
   */
  areaCodes: AreaCode[];

  /**
   * status filters by workflow case status. unset = no filtering.
   *
   * @generated from field: optional bffuser.v1.WorkflowCaseStatus status = 5;
   */
  status?: WorkflowCaseStatus;

  /**
   * has_actual_filter filters by whether the demand actual (実績) has arrived.
   * true = show only cases with actual data; false = show only cases without;
   * unset = no filtering.
   *
   * @generated from field: optional bool has_actual_filter = 6;
   */
  hasActualFilter?: boolean;
};

/**
 * Describes the message bffuser.v1.ListDemandForecastsRequest.
 * Use `create(ListDemandForecastsRequestSchema)` to create a new message.
 */
export const ListDemandForecastsRequestSchema: GenMessage<ListDemandForecastsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_service, 0);

/**
 * @generated from message bffuser.v1.ListDemandForecastsResponse
 */
export type ListDemandForecastsResponse = Message<"bffuser.v1.ListDemandForecastsResponse"> & {
  /**
   * rows are pre-composed display rows.
   *
   * @generated from field: repeated bffuser.v1.DemandForecastRow rows = 1;
   */
  rows: DemandForecastRow[];
};

/**
 * Describes the message bffuser.v1.ListDemandForecastsResponse.
 * Use `create(ListDemandForecastsResponseSchema)` to create a new message.
 */
export const ListDemandForecastsResponseSchema: GenMessage<ListDemandForecastsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_service, 1);

/**
 * DemandForecastRow is one display row of the demand forecast list screen.
 * It represents a combination of a workflow case, an area, and a retail BG.
 * Case-level fields (status / completed_* / peak_demand_mw / energy_mwh /
 * created_at) repeat across rows that share the same case_id; this is
 * intentional (denormalized for frontend simplicity).
 * read-only list: no optimistic lock field.
 *
 * @generated from message bffuser.v1.DemandForecastRow
 */
export type DemandForecastRow = Message<"bffuser.v1.DemandForecastRow"> & {
  /**
   * case_id is the WorkflowCase.id (UUIDv7). Used as the caseId path segment
   * when navigating to the detail screen.
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * target_date is the date shown in the target period column. Daily tabs
   * display a single date.
   *
   * @generated from field: google.type.Date target_date = 3;
   */
  targetDate?: Date;

  /**
   * section is used to resolve the section path segment for navigation.
   *
   * @generated from field: bffuser.v1.WorkflowSection section = 4;
   */
  section: WorkflowSection;

  /**
   * area_code is shown in the area column.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 5;
   */
  areaCode: AreaCode;

  /**
   * bg_code is shown in the BG code column. Sourced from the case's own BG
   * (WorkflowCase.DemandForecastBgCode() via the backend list row, #5053 fix). Unset for an
   * area-axis "BG なし" case; the frontend should display "—".
   *
   * @generated from field: optional string bg_code = 6;
   */
  bgCode?: string;

  /**
   * status is the workflow case status shown as a badge in the status column.
   *
   * @generated from field: bffuser.v1.WorkflowCaseStatus status = 7;
   */
  status: WorkflowCaseStatus;

  /**
   * completed_at is the 需要想定確定日時 shown in the 確定日時 column (the confirm
   * record's confirmed_at, NOT WorkflowCase completion). unset when the case has
   * never been confirmed; the frontend should display "—".
   *
   * @generated from field: optional google.protobuf.Timestamp completed_at = 8;
   */
  completedAt?: Timestamp;

  /**
   * completed_by is the 確定者 shown in the 確定者 column (the confirm record's
   * confirmed_by). unset when never confirmed; the frontend should display "—".
   *
   * @generated from field: optional string completed_by = 9;
   */
  completedBy?: string;

  /**
   * peak_demand_mw is the peak demand in MW (ピーク需要 MW) derived from the
   * confirmed demand forecast. Absent when the forecast has not yet been
   * confirmed; the frontend should display "—".
   *
   * @generated from field: optional google.type.Decimal peak_demand_mw = 10;
   */
  peakDemandMw?: Decimal;

  /**
   * energy_mwh is the total energy in MWh (電力量 MWh) derived from the
   * confirmed demand forecast. Absent when the forecast has not yet been
   * confirmed; the frontend should display "—".
   *
   * @generated from field: optional google.type.Decimal energy_mwh = 11;
   */
  energyMwh?: Decimal;

  /**
   * created_at is the creation timestamp of the underlying WorkflowCase.
   * Used for display in the created-at column and for descending sort.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;

  /**
   * workflow_id is the human-readable business key of the WorkflowCase
   * (e.g. "R-D1-20260430-B786"). Displayed in the workflow column.
   *
   * @generated from field: string workflow_id = 13;
   */
  workflowId: string;

  /**
   * record_id is the ConfirmRecord ID used to link to the evaluation screen.
   * Absent when no confirmed record exists for this case.
   *
   * @generated from field: optional string record_id = 14;
   */
  recordId?: string;

  /**
   * has_actual indicates whether the demand actual (実績) data has arrived
   * for this case. Used to show the "実績反映済" badge.
   *
   * @generated from field: bool has_actual = 15;
   */
  hasActual: boolean;

  /**
   * bg_name is the human-readable name of the BG (例: "東京第1BG"). Sourced
   * from WorkflowCase.BgName() via the backend list row (#5053 fix). Absent
   * when bg_code is absent, or when the snapshot itself is empty (defensive).
   *
   * @generated from field: optional string bg_name = 16;
   */
  bgName?: string;
};

/**
 * Describes the message bffuser.v1.DemandForecastRow.
 * Use `create(DemandForecastRowSchema)` to create a new message.
 */
export const DemandForecastRowSchema: GenMessage<DemandForecastRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_service, 2);

/**
 * DemandService provides Connect RPCs for the demand forecast (需要想定) domain.
 *
 * @generated from service bffuser.v1.DemandService
 */
export const DemandService: GenService<{
  /**
   * ListDemandForecasts returns the display rows for the demand forecast list
   * screen (需要想定一覧). The BFF handler calls backend ListDemandForecasts
   * to retrieve pre-composed rows. Row order is determined by the backend.
   *
   * @generated from rpc bffuser.v1.DemandService.ListDemandForecasts
   */
  listDemandForecasts: {
    methodKind: "unary";
    input: typeof ListDemandForecastsRequestSchema;
    output: typeof ListDemandForecastsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_demand_service, 0);

